import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import React from 'react';
import axios from "axios";
import { useSelector, useDispatch } from 'react-redux'
import { updateDetails } from '../slices/registerSlice';
import { useState } from "react";
import { useNavigate } from "react-router-dom"
import '../css/reg-SO.css';
import Navbar from 'react-bootstrap/Navbar';
import Logo from '../images/logos.png'
function SO_REG() {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    let { ownerDetails } = useSelector((state) => state.register);
    let { ownlist } = useSelector((state) => state.user)
    let [mail, existMail] = useState([]);
    const Change = (e) => {
        const value = (e.target.value);

        dispatch(updateDetails({
            ...ownerDetails,
            [e.target.name]: value
        }));

    };

    let [error, seterror] = useState({})


    const register = () => {

        let formData = new FormData();
        // formData.append("request", "create_shopowner")
        formData.append("name", ownerDetails.name)
        formData.append("email", ownerDetails.email)
        formData.append("password", ownerDetails.password)
        formData.append("request","allowregister")
        // formData.append("aadhar", ownerDetails.aadhar)
        // formData.append("street", ownerDetails.street)
        // formData.append("city", ownerDetails.city)
        // formData.append("area", ownerDetails.area)
        // formData.append("phone", ownerDetails.phone)
        // formData.append("pincode", ownerDetails.pincode)
        // formData.append("shop_name", ownerDetails.shop_name)
        console.log(formData)


        // let error = false
        // {Object.entries(ownerDetails).map(([key, value]) => {
        //     if (value == "") {
        //             alert("enter values of", key)
        //             error = true
        //         }

        //         if (error == false) {
                    axios.post('http://ajil.pythonanywhere.com/register', formData).then(function (response) {
                        console.log(response)
                        // if (response.data.status == "success") {
                        //     // navigate("/shopownerlogin");
                        // }
                    })
                }
    //         }
    //         )
    //     }
    // };

    return (
        <>
            <div className='login template  bg'>
                <div className='logopositions'>
                    <Navbar >
                        <Navbar.Brand href="#"><img src={Logo} alt='logo' width={90} id="logo" /></Navbar.Brand>

                    </Navbar>
                </div>
               
                    <div className='positionchange'>
                        <Form style={{minWidth:"350px",maxWidth:"600px"}} className='p-3'>
                            <h1 className='text-start mb-3'> Register </h1>
                            <Form.Group as={Row} className="mb-3" controlId="formPlaintextPassword">
                                <Form.Label column sm="3">
                                    UserName
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control type="text" name='name' placeholder="UserName" className='detail' required onChange={Change} />
                                    {/* {error.Username && <span style={{ color: "red" }}>{error.Username}</span>} */}
                                </Col>
                            </Form.Group>

                            {/* <Form.Group as={Row} className="mb-3" controlId="formPlaintextPassword">
                                <Form.Label column sm="3">
                                    ShopName
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control type="text" name='shop_name' placeholder="ShopName" className='detail' required onChange={Change} />
                                </Col>
                            </Form.Group> */}
                            <div>
                                <Form.Group as={Row} className="mb-3 mailbox" controlId="formPlaintextPassword">
                                    <Form.Label column sm="3">
                                        Email
                                    </Form.Label>
                                    <Col sm="10">
                                        <Form.Control type="email" name='email' placeholder="email" className='detail' required onChange={Change} />
                                        {/* {error.email && <span style={{ color: "red" }}>{error.email}</span>} */}
                                    </Col>
                                </Form.Group>

                                <Form.Group as={Row} className="mb-3 pasbox" controlId="formPlaintextPassword">
                                    <Form.Label column sm="3">
                                        Password
                                    </Form.Label>
                                    <Col sm="10">
                                        <Form.Control type="password" name='password' placeholder="Password" className='detail' required onChange={Change} />
                                        {/* {error.password && <span style={{ color: "red" }}>{error.password}</span>} */}
                                    </Col>
                                </Form.Group>
                            </div>
                            
                            <div className='d-flex justify-content-start '>
                                <button className='btn btn-success px-4 my-3' type='button' onClick={() => register()}>Register</button>

                            </div>
                        </Form>
                    </div>
                </div>

          

        </>
    )


}
export default SO_REG